<template>
  <span>
    <SelectComponent label="Remetente" v-model="selectedNumber" :options="numbers" text-field="label" value-field=""
      @input="changeNumber"></SelectComponent>
    <SelectComponent v-if="selectedNumber" label="Template" v-model="selectedTemplate" :options="templates"
      text-field="name" value-field="" :loading="fetchingTemplates"></SelectComponent>
    <TemplatePreview v-if="selectedTemplate" :template="selectedTemplate"></TemplatePreview>
  </span>
</template>

<script>
import SelectComponent from '@/components/form/SelectComponent.vue';
import TemplatePreview from '@/components/whatsappj/TemplatePreview.vue';
import defaultImage from '@/assets/img/card_header.png';

export default {
  name: 'TemplateSelectComponent',
  components: {
    TemplatePreview,
    SelectComponent,
  },
  props: {},
  data() {
    return {
      fetchingTemplates: false,
      numbers: [],
      templates: [],
      selectedNumber: '',
      selectedTemplate: '',
    };
  },
  created() {
    this.fetchNumbers();
  },
  methods: {
    fetchNumbers() {
      this.$store.dispatch('fetchWhatsappNumbers').then(
        (numbers) => {
          this.numbers = numbers.map((number) => ({
            ...number,
            label: `${number.phone_number} - ${number.name}`,
          }));
        },
      );
    },
    fetchTemplates() {
      this.fetchingTemplates = true;
      this.$store.dispatch('fetchWhatsappTemplates', {
        status: 'APPROVED',
        number: this.selectedNumber.whatsapp_identification ?? this.selectedNumber.phone_number,
      }).then(
        (templates) => {
          templates.forEach((template) => {
            if (template.header) {
              if (template.header.type === 'IMAGE') {
                if (!template.header.example_parameter) {
                  template.header.example_parameter = window.location.origin + defaultImage;
                }
              } else if (!template.header.example_parameter) {
                template.header.example_parameter = '';
              }
            }
          });
          this.templates = this.filterByAllowedCategories(templates);
        },
      ).finally(
        () => {
          this.fetchingTemplates = false;
        },
      );
    },
    filterByAllowedCategories(templates) {
      // Owners/admins see every category; the whitelist only restricts agents.
      // account.role is the dashboard-level RBAC and is reliable for non-agent users;
      // $live.profiles is only populated for AGENT userType so it can't be the sole signal.
      const role = this.$store?.state?.account?.role;
      if (role === 'owner' || role === 'admin') return templates;

      const profiles = this.$live?.profiles ?? [];
      if (profiles.indexOf('ADMINISTRATOR') !== -1 || profiles.indexOf('MANAGER') !== -1) return templates;

      const allowed = this.$live?.allowedTemplateCategories;
      if (!Array.isArray(allowed)) return templates;

      return templates.filter((template) => allowed.indexOf(template.category) !== -1);
    },
    changeNumber() {
      this.selectedTemplate = null;
      if (this.selectedNumber) {
        this.fetchTemplates();
      }
      this.$emit('changeNumber', this.selectedNumber.whatsapp_identification ?? this.selectedNumber.phone_number);
    },
  },
};
</script>
